export const DownloadFile = async (url: string, filename: string) => {
  const fetchedUrl = await fetch(url);
  const blobFile = await fetchedUrl.blob();
  const aElement = document.createElement('a');
  aElement.href = URL.createObjectURL(blobFile);
  aElement.setAttribute('download', filename);
  aElement.click();
};
